var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplyForIncentives(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7657 61.9999H1.04077V13.2469L6.66333 6.77184L11.9025 1.05859H47.0435V39.1469L45.8935 39.2739C40.782 39.7817 36.8207 44.0984 36.8207 49.3038C36.8207 54.5092 40.782 58.8259 45.8935 59.3337L47.0435 59.4607V61.8729L45.7657 61.9999Z",
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.430664 15.0242V12.4849H13.5637V0.18457H16.1194V15.0242H0.430664Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0434 61.9996C46.5323 61.9996 46.1489 61.9996 45.6378 61.8727C39.1207 61.2379 34.2649 55.7785 34.2649 49.3035C34.2649 42.8285 39.1207 37.3692 45.6378 36.7344C46.1489 36.7344 46.5323 36.6074 47.0434 36.6074C54.0716 36.6074 59.822 42.3207 59.822 49.3035C59.822 56.2864 54.0716 61.9996 47.0434 61.9996ZM47.0434 39.1466C46.6601 39.1466 46.2767 39.1466 45.8934 39.2736C40.7819 39.7814 36.8206 44.0981 36.8206 49.3035C36.8206 54.5089 40.7819 58.8256 45.8934 59.3334C46.2767 59.3334 46.6601 59.4604 47.0434 59.4604C52.666 59.4604 57.2663 54.8898 57.2663 49.3035C57.2663 43.7172 52.666 39.1466 47.0434 39.1466Z",
    fill: "#626262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5263 18.833H11.2634V21.3722H40.5263V18.833Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5263 25.1816H11.2634V27.7209H40.5263V25.1816Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5263 31.5293H11.2634V34.0685H40.5263V31.5293Z",
    fill: "#F2F2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5427 37.8774H11.2634V40.4167H35.5427V37.8774Z",
    fill: "#F2F2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.987 44.2256H11.2634V46.7648H32.987V44.2256Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9905 54.6457L40.6956 49.8229L42.3962 48.5368L44.4157 51.5377L52.1748 45L53.5565 46.6076L43.9905 54.6457Z",
    fill: "#626262"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyForIncentives);
export default __webpack_public_path__ + "static/media/apply-for-incentives.228535e31cc39974f345f776c06ce220.svg";
export { ForwardRef as ReactComponent };